module.exports = __webpack_public_path__ + "static/img/dingzuohong.62f106a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/dingzuohong.png
// module id = jW2B
// module chunks = 0